import {SUPPORTED_SPORTS} from "../constants/globalConstants";

export const formatPlayTime = {
    [SUPPORTED_SPORTS.FOOTBALL]: formatSoccerTime
}

function formatSoccerTime(globalSeconds: number, periodStr?: string): string {
    const seconds = globalSeconds || 0;
    const s = Math.max(0, Math.floor(seconds)); // Niente negativi / decimali

    // Calcoliamo i minuti e i secondi effettivi
    let min = Math.floor(s / 60);
    const secs = s % 60;
    const period = periodStr?.trim();

    // 1. GESTIONE PRE_MATCH E POST_MATCH
    if (period === "PRE_MATCH") return "PRE";
    if (period === "POST_MATCH") return "POST";
    if (period === "HALF_TIME" || period === "INTERVAL") return "INT";

    // 2. GESTIONE RIGORI
    if (period === "PENALTY_SHOOT_OUT") {
        if (secs > 0) min += 1;
        return `${min}′`;
    }

    // 3. ARROTONDAMENTO SECONDI
    if (secs > 0) min += 1;
    if (min === 0 && secs === 0) return "0′";

    // 4. CALCOLO BASE TEMPO REGOLAMENTARE / SUPPLEMENTARE
    let base = 0;
    if (period === "FIRST_HALF") base = 45;
    else if (period === "SECOND_HALF") base = 90;
    else if (period === "FIRST_PERIOD_OF_EXTRA_TIME") base = 105;
    else if (period === "SECOND_PERIOD_OF_EXTRA_TIME") base = 120;

    // 5. CALCOLO RECUPERO
    const extra = min - base;

    // 6. RITORNO FORMATO
    // Se non c'è recupero o non c'è una "base" definita, ritorna solo il minuto (es. 23')
    // Se c'è recupero, ritorna il formato base+recupero (es. 45'+2)
    return extra <= 0 ? `${min}′` : `${base}′+${extra}`;
}